import React from 'react';
import { View, Text } from 'react-native';
import { useThemeColors } from '@/lib/useThemeColors';
import { labelThemeColor, capitalizeLabel } from '@/lib/scoring/score-display';

interface ScoreSectionDividerProps {
  title: string;
  label?: string;
  score?: number | string;
  labelColorOverride?: string;
}

export function ScoreSectionDivider({
  title,
  label,
  score,
  labelColorOverride,
}: ScoreSectionDividerProps) {
  const colors = useThemeColors();
  const tint =
    labelColorOverride ??
    (label ? labelThemeColor(label, colors) : colors.text.tertiary);
  const labelDisplay = label ? capitalizeLabel(label) : '';

  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
        marginTop: 24,
        marginBottom: 12,
      }}
    >
      <Text
        style={{
          color: colors.text.primary,
          fontSize: 12,
          fontWeight: '700',
          letterSpacing: 1.4,
          textTransform: 'uppercase',
          flexShrink: 0,
        }}
        numberOfLines={1}
      >
        {title}
      </Text>
      <View style={{ flex: 1, height: 1, backgroundColor: colors.border.dark }} />
      {(label || score !== undefined) && (
        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 4 }}>
          {label && (
            <Text
              style={{
                color: tint,
                fontSize: 12,
                fontWeight: '700',
              }}
              numberOfLines={1}
            >
              {labelDisplay}
            </Text>
          )}
          {score !== undefined && (
            <Text
              style={{
                color: colors.text.secondary,
                fontSize: 12,
                fontWeight: '600',
              }}
              numberOfLines={1}
            >
              {label ? `(${score})` : score}
            </Text>
          )}
        </View>
      )}
    </View>
  );
}
